module.exports = __webpack_public_path__ + "static/media/Create Account noloop.0952106f.gif";